<div class="pedidos-topo">
  <h4 class="page-title"><i class="fe-shopping-cart"></i> Pedidos</h4>

  <div class="localizador-pedido">
    <button type="button" class="localizador-pedido__gatilho" [class.ativo]="exibirLocalizadorPedido"
            [attr.aria-expanded]="exibirLocalizadorPedido" aria-controls="painel-localizador-pedido"
            (click)="altereExibicaoLocalizadorPedido()">
      <i class="fe-search" aria-hidden="true"></i>
      <span>Localizar pedido</span>
    </button>

    <section id="painel-localizador-pedido" class="localizador-pedido__painel" role="search"
             aria-labelledby="titulo-localizador-pedido" *ngIf="exibirLocalizadorPedido"
             (keydown.escape)="fecheLocalizadorPedido()">
      <div class="localizador-pedido__cabecalho">
        <div>
          <strong id="titulo-localizador-pedido">Localizar pelo código</strong>
          <small>Consulte todo o histórico, inclusive pedidos antigos.</small>
        </div>
        <button type="button" class="localizador-pedido__fechar" aria-label="Fechar busca"
                (click)="fecheLocalizadorPedido()">&times;</button>
      </div>

      <form class="localizador-pedido__form" (ngSubmit)="localizePedidoPorCodigo()">
        <label for="codigo-localizar-pedido">Código do pedido</label>
        <div class="localizador-pedido__controles">
          <div class="localizador-pedido__campo" [class.localizador-pedido__campo--erro]="mensagemLocalizador">
            <span aria-hidden="true">#</span>
            <input id="codigo-localizar-pedido" name="codigoLocalizar" type="text" inputmode="numeric"
                   maxlength="9" autocomplete="off" placeholder="Ex.: 12556" appAutoFocus
                   [(ngModel)]="codigoLocalizar" (ngModelChange)="mensagemLocalizador = ''">
          </div>
          <button type="submit" class="btn btn-primary localizador-pedido__botao" [disabled]="localizandoPedido">
            <i [class]="localizandoPedido ? 'fa fa-spin fa-spinner' : 'fe-search'"></i>
            <span>{{localizandoPedido ? 'Localizando' : 'Localizar'}}</span>
          </button>
        </div>
        <div class="localizador-pedido__mensagem" role="status" aria-live="polite" *ngIf="mensagemLocalizador">
          <i class="fe-alert-circle" aria-hidden="true"></i>
          <span>{{mensagemLocalizador}}</span>
        </div>
      </form>
    </section>
  </div>
</div>

<app-chamada-recurso-contextual
  slug="kds_cozinha"
  origem="pedidos"
  titulo="Sua cozinha pode acompanhar os pedidos por uma tela"
  descricao="Conheça o KDS e organize cada etapa do preparo."
  icone="fa-desktop">
</app-chamada-recurso-contextual>

<h5  [hidden]="!empresa?.integracoesIfood?.length" #appendTo class="mb-2">
  Aceitar pedidos automaticamente
  <kendo-switch [(ngModel)]="empresa.aceitarPedidoAutomatico" (ngModelChange)="alterouAceitarAutomatico($event)"
                name="aceitarPedidoAutomatico" id="aceitarPedidoAutomatico"  ></kendo-switch>
</h5>

<div class=" " style="background: #fff; padding-top: 5px">
  <kendo-tabstrip class="nav-bordered mt-3" >
    <kendo-tabstrip-tab [title]="'Em aberto'" [selected]="true">
      <ng-template kendoTabContent>
        <app-tela-acompanhar-pedidos [empresa]="empresa" ></app-tela-acompanhar-pedidos>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab [title]="'Agendados'">
      <ng-template kendoTabContent>
        <app-tela-acompanhar-pedidos [apenasAgendados]="true" [empresa]="empresa"></app-tela-acompanhar-pedidos>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab [title]="'Fiados (Abertos)'" *ngIf="moduloFiadoAtivo">
      <ng-template kendoTabContent>
        <app-tela-acompanhar-pedidos [apenasFiados]="true" [empresa]="empresa"></app-tela-acompanhar-pedidos>
      </ng-template>
    </kendo-tabstrip-tab>


    <kendo-tabstrip-tab [title]="'Finalizados'">
      <ng-template kendoTabContent>
        <app-tela-pedidos-pagos [empresa]="empresa"></app-tela-pedidos-pagos>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab [title]="'Cancelados'">
      <ng-template kendoTabContent>
        <app-tela-pedidos-cancelados [empresa]="empresa"></app-tela-pedidos-cancelados>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</div>

